import * as React from 'react'
import SystemDropDown, { SystemBaseList }  from './SystemDropDown'
import { SystemBase } from '../../library/common/SystemBase';



export default class SystemUserDropDown extends SystemBaseList{
    static defaultProps = {
        ...SystemBase.defaultProps,       
    }
    constructor(props: any) { 
        super(props)
    }

    handleOnChange = (event, name, value) => {     
        this.handleChange(event, value, name);
    }
    render() {
        return (
            <SystemDropDown {...this.props}
                dataSource={'/SecurityUserSummary'}
                displayField='FullName'
                idField='UserId'
                onChange={this.handleOnChange}
                value={this.props.value}
              
            />
        )
    }
}

